import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.config.productionTip = false

import '@/permission'
import router from './router'
import store from './store'
import './utils/directives'
import 'amfe-flexible'
import i18n from './lang' // internationalization

import '@/assets/style/common.css'
import '@/assets/style/theme.scss'
import '@/assets/style/element.scss'
import '@/assets/fonts/iconfont.css'
import 'nprogress/nprogress.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// 自定义表单
import CustomUpload from '@/components/formCreate/CustomUpload.vue'
import formCreate from '@form-create/element-ui'
formCreate.component('CustomUpload', CustomUpload)
Vue.use(formCreate)

// require('promise.prototype.finally').shim()

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
